import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import ReturnGoodsActions from "../../../../reducers/modules/warehouse/return-goods/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";
import { isWeakMap } from "lodash";
import i18n from "../../../../i18n";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "warehouse/return-goods";

export default class ReturnGoodsMiddleware {
  static create(params) {
    return (dispatch) => {
      dispatch(ReturnGoodsActions.create());
      ReturnGoodsMiddleware.showHelperFull(dispatch, params);
    };
  }

  static getDataGoods(params) {
    return (dispatch) => {
       dispatch(ReturnGoodsActions.process());
      ReturnGoodsMiddleware.showDataGoods(dispatch, params);
    };
  }

  static beforeSaveReturn(post, search) {
    return (dispatch) => {
      dispatch(ReturnGoodsActions.submit());
      ReturnGoodsMiddleware.saveReturn(dispatch, post, search);
    };
  }

  static return(params) {
    return (dispatch) => {
      dispatch(ReturnGoodsActions.return());
      // ReturnGoodsMiddleware.showHelperFull(dispatch, params);
      ReturnGoodsMiddleware.showOneData(dispatch, params);
    };
  }

  static viewItem(params) {
    return (dispatch) => {
      dispatch(ReturnGoodsActions.viewItem());
      // ReturnGoodsMiddleware.showHelperFull(dispatch, params);
      ReturnGoodsMiddleware.showOneView(dispatch, params);
    };
  }

  static list(params) {
    return (dispatch) => {
      dispatch(ReturnGoodsActions.process());
      ReturnGoodsMiddleware.showlist(dispatch, params);
    };
  }
  static reset() {
    return (dispatch) => {
      dispatch(ReturnGoodsActions.reset());
    };
  }

  static getPrint(params) {
    return (dispatch) => {
      dispatch(ReturnGoodsActions.beforePrint());
      ReturnGoodsMiddleware.showPrint(dispatch, params);
    };
  }

  static resetList() {
    return (dispatch) => {
      dispatch(ReturnGoodsActions.resetList());
    };
  }
  static getOne(params) {
    return (dispatch) => {
      dispatch(ReturnGoodsActions.view());
      ReturnGoodsMiddleware.showOne(dispatch, params);
    };
  }


  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(ReturnGoodsActions.submit());
      ReturnGoodsMiddleware.saveNew(dispatch, post, search);
    };
  }

  static beforeSaveReturn(post, search) {
    return (dispatch) => {
      dispatch(ReturnGoodsActions.submit());
      ReturnGoodsMiddleware.saveReturn(dispatch, post, search);
    };
  }

  static beforeSaveUpdate(params, post, search) {
    return (dispatch) => {
      dispatch(ReturnGoodsActions.submit());
      ReturnGoodsMiddleware.saveUpdate(dispatch, params, post, search);
    };
  }
  static beforeDelete(id, params) {
    return (dispatch) => {
      dispatch(ReturnGoodsActions.delete());
      ReturnGoodsMiddleware.delete(dispatch, params, id);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }
  static getHelperFull(params = null) {
    return (dispatch) => {
      ReturnGoodsMiddleware.showHelperFull(dispatch, params);
    };
  }

  static showHelperFull(dispatch, params, date) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ReturnGoodsMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-taking-goods-helper",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(ReturnGoodsActions.helperFull(response.data.result));
        }
      })
      .catch((error) => {
        ReturnGoodsMiddleware.alertHendler(dispatch, error);
      });
  }

  static showPrint(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ReturnGoodsMiddleware.getToken()}`,
      },
      url: url + "/print/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(ReturnGoodsActions.print(response.data.result));
        }
      })
      .catch((error) => {
        ReturnGoodsMiddleware.alertHendler(dispatch, error);
      });
  }


  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ReturnGoodsMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(ReturnGoodsActions.list(response.data.result));
        }
      })
      .catch((error) => {
        ReturnGoodsMiddleware.alertHendler(dispatch, error);
      });
  }

  static showDataGoods(dispatch, post, search) {
   axios({
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${ReturnGoodsMiddleware.getToken()}`,
      },
      url: url + '/show-data',
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(ReturnGoodsActions.dataGoods(response.data.result));
        }
      })
      .catch((error) => {
        console.log(error)
        ReturnGoodsMiddleware.alertHendler(dispatch, error, true);
      });
  }

   static saveReturn(dispatch, post, params) {
   axios({
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${ReturnGoodsMiddleware.getToken()}`,
      },
      url: url + '/save',
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
           dispatch(
            ReturnGoodsActions.process(),
            ReturnGoodsMiddleware.showlist(dispatch, params)
          );
          dispatch(ReturnGoodsActions.success());
          ReturnGoodsMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Save Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        ReturnGoodsMiddleware.alertHendler(dispatch, error, true);
      });
  }
  

  static showOneData(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ReturnGoodsMiddleware.getToken()}`,
      },
      url: url + "/return/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(ReturnGoodsActions.view(response.data.result));
        }
      })
      .catch((error) => {
        ReturnGoodsMiddleware.alertHendler(dispatch, error);
      });
  }

  static showOneView(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ReturnGoodsMiddleware.getToken()}`,
      },
      url: url + "/view-item/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(ReturnGoodsActions.view(response.data.result));
        }
      })
      .catch((error) => {
        ReturnGoodsMiddleware.alertHendler(dispatch, error);
      });
  }

  static delete(dispatch, params, id) {
    axios({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ReturnGoodsMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            ReturnGoodsActions.process(),
            ReturnGoodsMiddleware.showlist(dispatch, params)
          );
          ReturnGoodsMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Delete Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        ReturnGoodsMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${ReturnGoodsMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            ReturnGoodsActions.process(),
            ReturnGoodsMiddleware.showlist(dispatch, search)
          );
          dispatch(ReturnGoodsActions.success());
          ReturnGoodsMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Create Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        ReturnGoodsMiddleware.alertHendler(dispatch, error);
      });
  }

  // static saveReturn(dispatch, post, search) {
  //   axios({
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "multipart/form-data",
  //       Authorization: `Bearer ${ReturnGoodsMiddleware.getToken()}`,
  //     },
  //     url: url+'/save-return',
  //     data: post,
  //     responseType: "json",
  //   })
  //     .then((response) => {
  //       if (response && response.status === 200 && response.data) {
  //         dispatch(
  //           ReturnGoodsActions.process(),
  //           ReturnGoodsMiddleware.showlist(dispatch, search)
  //         );
  //         dispatch(ReturnGoodsActions.success());
  //         ReturnGoodsMiddleware.alertHendler(
  //           dispatch,
  //           response,
  //           true,
  //           "Return Taking Goods Data Successfully",
  //           "success"
  //         );
  //       }
  //     })
  //     .catch((error) => {
  //       ReturnGoodsMiddleware.alertHendler(dispatch, error);
  //     });
  // }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${ReturnGoodsMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            ReturnGoodsActions.process(),
            ReturnGoodsMiddleware.showlist(dispatch, search)
          );
          dispatch(ReturnGoodsActions.success());
          ReturnGoodsMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        ReturnGoodsMiddleware.alertHendler(dispatch, error);
      });
  }

  static beforeApprove(id, value, search) {
    const post = {
      id: id,
      value: value,
    };
    return (dispatch) => {
      dispatch(ReturnGoodsActions.approve());
      ReturnGoodsMiddleware.saveApprove(dispatch, post, search);
    };
  }
  static beforeReject(id, value, search) {
    const post = {
      id: id,
      value: value,
    };
    return (dispatch) => {
      dispatch(ReturnGoodsActions.reject());
      ReturnGoodsMiddleware.saveReject(dispatch, post, search);
    };
  }

  static saveApprove(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ReturnGoodsMiddleware.getToken()}`,
      },
      url: url + "/approve/" + post.id,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            ReturnGoodsActions.process(),
            ReturnGoodsMiddleware.showlist(dispatch, search)
          );
          dispatch(ReturnGoodsActions.success());
          ReturnGoodsMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Approve Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        ReturnGoodsMiddleware.alertHendler(dispatch, error, true);
      });
  }
  static saveReject(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ReturnGoodsMiddleware.getToken()}`,
      },
      url: url + "/reject/" + post.id,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            ReturnGoodsActions.process(),
            ReturnGoodsMiddleware.showlist(dispatch, search)
          );
          dispatch(ReturnGoodsActions.success());
          ReturnGoodsMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Reject Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        ReturnGoodsMiddleware.alertHendler(dispatch, error, true);
      });
  }



  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              const msg = i18n.t(data.error)
              MySwal.hideLoading();
              MySwal.fire({
                title: "Info",
                html: msg,
                icon: "info",
                showConfirmButton: true,
              });
              dispatch(ReturnGoodsActions.error(data.error));
            } else {
              const data = result.response.data;
              // dispatch(ReturnGoodsActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
